export const gl = {
    LEFT: 'Esquerda: Mover para o día anterior.',
    RIGHT: 'Dereita: Mover para o día seguinte.',
    DOWN: 'Abaixo: ir á seguinte liña. | | - Se: Mover a liña anterior.',
    UP: 'PgUp: Mover ao mes anterior.',
    PGUP: 'PgDown: Move para o próximo mes.',
    PGDOWN: 'Casa: Mover ao ano anterior.',
    HOME: 'Final: Move para o próximo ano.',
    END: 'Esc/Hoxe/Pechar: pecha o calendario.',
    ESC: 'Teclado Instrucións'
};
